export enum Sentiment {
  Positive = "Positive",
  Negative = "Negative",
  Neutral = "Neutral",
  Mixed = "Mixed",
}

export interface SentimentTrendPoint {
  date: string;
  sentiment?: Sentiment;
  sessionCount: number;
}

export interface SentimentDistribution {
  positive: number;
  neutral: number;
  negative: number;
  mixed: number;
}

export interface SentimentAlert {
  type: "negative_streak" | "inactivity";
  label: string;
}

export interface SentimentSummaryResponse {
  patientId?: string;
  lastActiveAt?: string | null;
  trend: SentimentTrendPoint[];
  last7Days: SentimentTrendPoint[];
  distribution: SentimentDistribution;
  alerts?: SentimentAlert[];
}

export const SENTIMENT_EMOJI: Record<Sentiment, string> = {
  [Sentiment.Positive]: "🙂",
  [Sentiment.Negative]: "😔",
  [Sentiment.Mixed]: "🫤",
  [Sentiment.Neutral]: "😐",
};
